import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BankAccountService } from '../../../services/bankAccount.service';
import { BankAccount } from '../../../models/bankAccount.model';
import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';
import { PaginatorModule } from 'primeng/paginator';
import { TableModule } from 'primeng/table';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DropdownModule } from 'primeng/dropdown';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, InputTextModule, ButtonModule, TableModule, PaginatorModule, DropdownModule],
  selector: 'app-list-bank-accounts',
  templateUrl: './list-bank-accounts.component.html',
  styleUrls: ['./list-bank-accounts.component.css'],
  providers: [BankAccountService],
})
export class ListBankAccountsComponent implements OnInit {
  bankAccounts: BankAccount[] = [];
  searchTerm = '';
  loading = true;
  totalRecords = 0;
  first = 0;
  rows = 5;
  activeFilter: string = 'ativo';
  statusOptions = [
    { label: 'Ativo', value: 'ativo' },
    { label: 'Inativo', value: 'inativo' }
  ];

  constructor(
    private bankAccountService: BankAccountService,
    public router: Router
  ) {}

  ngOnInit(): void {
    this.loadBankAccounts();
  }

  loadBankAccounts() {
    this.loading = true;
    let active: boolean | undefined = undefined;
    if (this.activeFilter === 'ativo') active = true;
    else if (this.activeFilter === 'inativo') active = false;
    this.bankAccountService.list(this.searchTerm, active).subscribe({
      next: (response) => {
        this.bankAccounts = response.data;
        this.totalRecords = response.pagination?.totalRecords || 0;
        this.loading = false;
      },
      error: () => {
        this.bankAccounts = [];
        this.loading = false;
      },
    });
  }

  applyFilters() {
    this.loadBankAccounts();
  }

  createBankAccount() {
    this.router.navigate(['/app/financial/bank-accounts/new']);
  }

  edit(bankAccount: BankAccount) {
    this.router.navigate(['/app/financial/bank-accounts/edit', bankAccount.id]);
  }

  delete(bankAccount: BankAccount) {
    if (confirm('Tem certeza que deseja deletar esta conta bancária?')) {
      this.bankAccountService.delete(bankAccount.id).subscribe({
        next: () => this.loadBankAccounts(),
        error: () => alert('Erro ao deletar conta bancária.')
      });
    }
  }

  onPageChange(event: any) {
    this.first = event.first;
    this.rows = event.rows;
    // Aqui você pode implementar a lógica para buscar a página correta se o backend suportar paginação
    this.loadBankAccounts();
  }
} 